"use client";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import ConfirmDialog from "@/components/ConfirmDialog";

type Props = {
    open: boolean;
    houseRules: Array<{ id: number; rule: string }>;
    onAgree: () => void;
    onClose: () => void;
};

/**
 * Pre-submit pop-up so the guest reads the restaurant's house rules and agrees to them before the
 * booking goes through. BookingSummary shows it once per summary, ahead of the location check.
 */
export const HouseRulesDialog = ({ open, houseRules, onAgree, onClose }: Props) => (
    <ConfirmDialog
        open={open}
        onClose={onClose}
        title="House rules"
        showWarningIcon={false}
        primaryButtonText="I agree and continue"
        onPrimaryButtonClick={onAgree}
        secondaryButtonText="Back"
        fullWidth
        maxWidth="sm"
    >
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Please read these before we send your booking.
        </Typography>
        <List disablePadding>
            {houseRules.map((rule) => (
                <ListItem key={rule.id} alignItems="flex-start" sx={{ px: 0, py: 1 }}>
                    <ListItemIcon sx={{ minWidth: 36, mt: 0.5 }}>
                        <InfoOutlinedIcon sx={{ color: "primary.main", fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={rule.rule}
                        primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
                    />
                </ListItem>
            ))}
        </List>
    </ConfirmDialog>
);
